import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'releaseNotes',
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  } // mounted goes here 
  ,
  components: {
    // components go here
  },
  props: {
    // props go here
  },
  data: function data() {
    return {
      // <b>Community</b>
      releases: [{
        version: '0.0.1',
        date: '1-29-2023',
        title: 'Pre-alpha Release',
        notes: ['added <b>How To Docs</b> to main menu', 'added <b>Privacy Policy</b> to main menu', 'added <b>Terms of Service</b> to main menu', 'added <b>Community Guidelines</b> component', 'Added <b>Billing</b> section and link to <b>stripe billing</b> within main menu', 'added <b>Feedback & Support</b> to main menu', 'added <b>Release Notes</b> to main menu', 'added <b>Community Guidelines</b> component'],
        images: [
          // {
          // 	src: 'https://i.imgur.com/1ZQ2Z1K.png',
          // 	alt: 'main menu',
          // }
        ]
      }]
    };
  },
  methods: {
    // methods go here
  }
});